import React, { useState } from 'react'
import { Collapse, List, Checkbox, Select, message, Tag } from 'antd'

import { ActivityItemFile, FileFolderData, FilesData } from '../types/types'
import moment from 'moment'
import { ActivityItemFileWDate } from '../../activity-timeline'

export const FileManagerFolder: React.FC<{
  files: ActivityItemFileWDate[]
  folderName: string
  description?: string
  showFolderTag?: boolean
  onSelect: (id: number, item: ActivityItemFileWDate) => void
  selectedFiles: Map<number, ActivityItemFileWDate>
}> = ({ files, folderName, onSelect, description: desc, showFolderTag, selectedFiles }) => {
  const formatDate = (tst: string) => {
    return moment.unix(+tst).format('DD.MM.YY')
  }

  const allSelected = files.length > 0 && files.every(file => {
    const fileData = file.data as { id: number; files: FilesData[]; title?: string; folder?: FileFolderData }
    return selectedFiles.has(fileData.id)
  })

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      files.forEach(file => {
        const fileData = file.data as { id: number; files: FilesData[]; title?: string; folder?: FileFolderData }
        if (!selectedFiles.has(fileData.id)) {
          onSelect(fileData.id, file)
        }
      })
    } else {
      files.forEach(file => {
        const fileData = file.data as { id: number; files: FilesData[]; title?: string; folder?: FileFolderData }
        if (selectedFiles.has(fileData.id)) {
          onSelect(fileData.id, file)
        }
      })
    }
  }

  const collapseItems = [
    {
      key: '0',
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Checkbox
            checked={allSelected}
            onChange={(e) => handleSelectAll(e.target.checked)}
            onClick={(e) => e.stopPropagation()}
          >
            {folderName}
          </Checkbox>
        </div>
      ),
      children: (
        <>
          {desc && <p>{desc}</p>}
          <List itemLayout="vertical">
            {files.map(activityItem => {
              const fileData = activityItem.data as {
                id: number
                files: FilesData[]
                title?: string
                folder?: FileFolderData
              }
              return (
                <List.Item key={fileData.id}>
                  <Checkbox
                    checked={selectedFiles.has(fileData.id)}
                    onChange={() => onSelect(fileData.id, activityItem)}
                  >
                    <div>
                      <b>{`${fileData.title || 'Файл'} `}</b>
                      <a
                        target="_blank"
                        href={fileData.files?.[0].url}
                      >{`${fileData.files?.[0].name}`}</a>
                    </div>
                  </Checkbox>
                  {showFolderTag && fileData.folder && (
                    <Tag color="default">{fileData.folder.name}</Tag>
                  )}
                </List.Item>
              )
            })}
          </List>
        </>
      ),
    },
  ]

  return <Collapse items={collapseItems} />
}